import React from 'react';
import { Link } from 'react-router-dom';
import { HOSTEL_INFO, LOGO_URL, NAV_LINKS, WHATSAPP_LINK, CALL_LINK } from '../data/mockData';
import { Phone, Mail, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0E0E0E] border-t border-[#1E1E1E]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt={HOSTEL_INFO.name}
                className="h-10 w-10 rounded-full object-cover"
                style={{ mixBlendMode: 'screen' }}
              />
              <span className="text-[#F5F0E8] font-bold text-lg font-heading">MISFiTS</span>
            </Link>
            <p className="text-[#6A6050] text-sm leading-relaxed">
              A home for wanderers in the heart of Seraj Valley. Where MISFiTS find their tribe.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#D4A843] text-xs uppercase tracking-widest font-semibold mb-5">Quick Links</h4>
            <div className="space-y-3">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="block text-[#8A8070] hover:text-[#F5F0E8] transition-colors duration-300 text-sm"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#D4A843] text-xs uppercase tracking-widest font-semibold mb-5">Get in Touch</h4>
            <div className="space-y-4">
              <a
                href={CALL_LINK}
                className="flex items-center gap-3 text-[#8A8070] hover:text-[#F5F0E8] transition-colors duration-300 text-sm"
              >
                <Phone size={14} className="text-[#D4A843]" />
                {HOSTEL_INFO.phone}
              </a>
              <a
                href={`mailto:${HOSTEL_INFO.email}`}
                className="flex items-center gap-3 text-[#8A8070] hover:text-[#F5F0E8] transition-colors duration-300 text-sm"
              >
                <Mail size={14} className="text-[#D4A843]" />
                {HOSTEL_INFO.email}
              </a>
            </div>
          </div>

          {/* CTA */}
          <div>
            <h4 className="text-[#D4A843] text-xs uppercase tracking-widest font-semibold mb-5">Book Your Stay</h4>
            <div className="space-y-3">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#D4A843] text-[#1C1C1C] px-5 py-3 rounded-full text-sm font-semibold hover:bg-[#E8B940] transition-colors duration-300 w-full"
              >
                Book on WhatsApp
                <ArrowUpRight size={14} />
              </a>
              <a
                href={CALL_LINK}
                className="flex items-center justify-center gap-2 border border-[#3A3A3A] text-[#F5F0E8] px-5 py-3 rounded-full text-sm font-medium hover:border-[#D4A843] hover:text-[#D4A843] transition-colors duration-300 w-full"
              >
                Call Now
                <Phone size={14} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-[#1E1E1E] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#4A4A4A] text-xs">
            &copy; {new Date().getFullYear()} MISFiTS Hostel & Cafe. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={HOSTEL_INFO.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#4A4A4A] hover:text-[#D4A843] transition-colors duration-300 text-xs uppercase tracking-wider"
            >
              Instagram
            </a>
            <span className="text-[#2A2A2A]">|</span>
            <a
              href="https://maps.app.goo.gl/HTaWpiBVqh2TaKmZA"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#4A4A4A] hover:text-[#D4A843] transition-colors duration-300 text-xs uppercase tracking-wider"
            >
              Google Maps
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
